<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">NAAC Committee</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">NAAC Committee</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="minority-cell ptb--100 ">
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="table-responsive">
          <table class="table table-bordered table-striped table--4">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th>Name</th>
                <th>NAAC Criteria’s</th>
                <th>Role in the Committee</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Dr. Aarti Deshpande</td>
                <td>Principal</td>
                <td>Chairperson</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Dr. Sachin.V. Chavan</td>
                <td>Extended Templates</td>
                <td>NAAC Coordinator</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Prof. Sarika Kulthe</td>
                <td>1.Curricular Aspects</td>
                <td>In charge<br>
                  <strong>Members:</strong>
                  <ul class="ullist">
                    <li>1. Prof. Ashwini Kamble</li>
                    <li>2. Prof. Neha Daga</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>4</td>
                <td>Prof. Prof. Smita Muley</td>
                <td>2.Teaching Learning and Evaluation</td>
                <td>In charge<br>
                  <strong>Members:</strong>
                  <ul class="ullist">
                    <li>1. Prof. Nilam Dhage</li>
                    <li>2. Prof. Shika Shastri</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>5</td>
                <td>Prof.Venkat Wadgave</td>
                <td>3.Research, Innovation and Extensions</td>
                <td>In charge<br>
                  <strong>Members:</strong>
                  <ul class="ullist">
                    <li>1. Prof. Jogdande Pramila</li>
                    <li>2. Prof. Nehe Niranjan</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>6</td>
                <td>Prof. M. B. Pisal</td>
                <td>4.Infrastructure, Learning and Resources</td>
                <td>In charge<br>
                  <strong>Members:</strong>
                  <ul class="ullist">
                    <li>1. Prof. Nitin Choudhari</li>
                    <li>2. Mrs. Ujjwala Matathe</li>
                    <li>3. Prof. Mohan Barawkar</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>7</td>
                <td>Prof. Cheena Kabra</td>
                <td>5.Students Support and Progression</td>
                <td>In charge<br>
                  <strong>Members:</strong>
                  <ul class="ullist">
                    <li>1. Prof. Dattaray Pande</li>
                    <li>2. Prof. Mohini Pardeshi</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>8</td>
                <td>Prof. Prafulla Jadhav</td>
                <td>6.Goverance and Leadership</td>
                <td>In charge<br>
                  <strong>Members:</strong>
                  <ul class="ullist">
                    <li>1. Prof. Snehal Dalvi</li>
                    <li>2. Prof. Rohini Deshmukh</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>9</td>
                <td>Prof. Jayashree Jadhav</td>
                <td>7.Institutional Values and Best Practices</td>
                <td>In charge<br>
                  <strong>Members:</strong>
                  <ul class="ullist">
                    <li>1. Prof. B. Surve</li>
                    <li>2. Prof. Komal Nikam</li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</section>
